import type { MouseEvent } from "react";
import classNames from "classnames";
import { t } from "@/i18n-js/instance";
import { ProgressiveImage } from "@circle-react/components/shared/ProgressiveImage";
import { isEventPost } from "@circle-react/helpers/postHelpers";
import type { Post } from "@circle-react/types";
import { ShowPageLink } from "./ShowPageLink";

export interface PostCoverImageProps {
  className?: string;
  endsAt?: string;
  onClick?: (event: MouseEvent<HTMLAnchorElement>) => void;
  post: Post;
  startsAt?: string;
  timeZone?: string;
  wrapperClassName?: string;
}

export const PostCoverImage = ({
  post,
  className = "",
  wrapperClassName = "",
  ...rest
}: PostCoverImageProps) => {
  const isEventPostType = isEventPost(post);
  const coverImageUrl =
    post.cover_image_variants?.large ?? post.cover_image_url;

  if (!coverImageUrl) {
    return null;
  }

  return (
    <div className={classNames("px-5 pt-5 md:p-0", wrapperClassName)}>
      <ShowPageLink
        shouldOpenPostModal
        post={post}
        className="post__cover focus-visible:outline-secondary focus-visible:text-dark block focus-visible:rounded-lg focus-visible:outline focus-visible:outline-2 focus-visible:md:rounded-b-none"
        {...rest}
      >
        {post.cover_image_variants && (
          <ProgressiveImage
            key={post.cover_image_url ?? ""}
            src={post.cover_image_url ?? ""}
            srcVariants={post.cover_image_variants}
            alt={t("post.cover_image_alt")}
            className={classNames("w-full object-cover", className, {
              "md:rounded-b-none": !isEventPostType,
              "rounded-lg": isEventPostType,
              "rounded-2xl": !isEventPostType,
            })}
          />
        )}
      </ShowPageLink>
    </div>
  );
};
